import { cdAxios } from "../../../lib/axios";
import { keycloak } from "../../../lib/keycloak";
import { ContactsService } from "./service";

export class ContactsServiceImpl implements ContactsService {
  public updateSendEmails(contactId: string, sendEmails: string[]): Promise<void> {
    return cdAxios
      .put(
        "/api/contacts/" +
        contactId +
        "/send-emails",
        {
          sendEmails: sendEmails
        },
        {
          headers: {
            Authorization: "Bearer " + keycloak.token,
            Accept: "*/*",
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);
  }
}
